/**
 * Parses query parameters from a given URL, relative path, or query string.
 *
 * If a parameter appears multiple times (e.g., `?tag=a&tag=b`), its values are
 * collected into an array. Otherwise, values remain as strings.
 *
 * This replicates the legacy `location.query` behavior from React Router v3,
 * which was removed in later versions. Unlike `qs.parse()`, this performs only
 * shallow parsing, which is sufficient for basic array support.
 *
 * Used in our React Router implementation (see usages in codebase).
 *
 * @param href - A full or relative URL, or a query string starting with `?`.
 * @returns An object representing the query parameters.
 */
export function parseUrlQuery(href: string): Record<string, string | string[]> {
  const searchParams = new URL(href, 'https://example.com').searchParams
  const query: Record<string, string | string[]> = {}

  for (const [key, value] of searchParams.entries()) {
    if (Object.hasOwn(query, key)) {
      query[key] = ([] as string[]).concat(query[key], value)
    } else {
      query[key] = value
    }
  }

  return query
}
